<template>
<v-container flex grid-list-lg>
    <template v-if="!smartLock">
      <smart-lock-message></smart-lock-message>
    </template>
    <v-layout row wrap v-else>
        <v-flex xs12>
            <v-toolbar color="#eee" class="elevation-0 secondary--text">
                <v-toolbar-title>Rede de Empresas</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-slide-x-transition>
                    <v-layout justify-end v-show="searchingRede">
                        <v-flex xs3>
                            <v-select
                                outline
                                hide-details
                                single-line
                                placeholder="Filtrar por"
                                :items="[
                                    {
                                        value: 'nome__icontains',
                                        text: 'Nome da Rede',
                                        tipo: 'text',
                                        mask: ''
                                    },
                                    {
                                        value: 'is_white_label',
                                        text: 'White Label',
                                        tipo: 'checklist',
                                        mask: ''
                                    }
                                ]"
                                item-text="text"
                                v-model="filtro"
                                return-object
                            ></v-select>
                        </v-flex>
                        <v-flex xs4 v-if="filtro && filtro.tipo === 'text'">
                            <v-text-field
                                outline
                                hide-details
                                single-line
                                :placeholder="filtro.text"
                                :mask="filtro.mask"
                                v-model="campoPesquisa"
                                @keyup.enter="buscarAgora"
                            ></v-text-field>
                        </v-flex>
                        <v-flex xs4 v-else-if="filtro && filtro.tipo === 'checklist'">
                            <v-checkbox
                                v-model="campoPesquisa"
                                color="primary"
                                class="mt-2"
                                :hide-details="campoPesquisa"
                            >
                                <template slot="label">
                                    <span class="body-2 grey--text">{{ filtro.text }}</span>
                                </template>
                            </v-checkbox>
                        </v-flex>
                    </v-layout>
                </v-slide-x-transition>
                <v-btn icon color="info" @click="searchingRede = !searchingRede">
                    <v-icon v-if="!searchingRede">search</v-icon>
                    <v-icon v-else>close</v-icon>
                </v-btn>
                <v-tooltip bottom>
                    <v-btn @click="dialogFirebase = true" slot="activator" color="info" icon>
                        <v-icon>local_fire_department</v-icon>
                    </v-btn>
                    <span>Gerenciar Projetos Firebase</span>
                </v-tooltip>
                <v-tooltip bottom>
                    <v-btn @click="dialogCadRede = true" slot="activator" color="info" icon>
                        <v-icon>add</v-icon>
                    </v-btn>
                    <span>Cadastrar Nova Rede</span>
                </v-tooltip>
            </v-toolbar>
        </v-flex>
        <v-flex xs12>
            <v-data-table
                :headers="[
                    {
                        align: 'left',
                        sortable: false,
                        value: 'icone'
                    },
                    {
                        text: 'Nome',
                        align: 'left',
                        sortable: false,
                        value: 'nome'
                    },
                    {
                        text: 'Empresa Matriz',
                        sortable: false,
                        value: 'matriz'
                    },
                    {
                        text: 'Tipo',
                        sortable: false,
                        value: 'is_white_label'
                    },
                    {
                        text: 'Representante',
                        sortable: false,
                        value: 'matriz.cnpj'
                    },
                ]"
                :items="redes"
                :loading="loading"
                :pagination.sync="pagination"
                :total-items="totalItens"
                hide-actions
            >
                <v-progress-linear slot="progress" color="blue" indeterminate></v-progress-linear>
                <template slot="headerCell" slot-scope="{ header }">
                    <span class="font-weight-light" v-text="header.text" />
                </template>
                <template slot="items" slot-scope="props">
                    <td>
                        <v-icon :color="props.item.is_white_label ? 'secondary' : ''">
                            ac_unit
                        </v-icon>
                    </td>
                    <td>{{ props.item.nome }}</td>
                    <td class="text-xs-left">
                        {{ props.item.matriz ? props.item.matriz.nome_fantasia : '' }}
                        <br v-if="props.item.matriz">
                        {{ props.item.matriz ? `CNPJ: ${props.item.matriz.cnpj}` : '' }}
                    </td>
                    <td class="text-xs-left">
                        {{ props.item.is_white_label ? 'White Label' : 'Padrão' }}
                    </td>
                    <td
                        class="text-xs-left"
                        v-html="props.item.representante ? `${props.item.representante.nome} ${props.item.representante.sobrenome}`: `Automação ${props.item.empresa_automacao}` "
                    ></td>
                    <td class="text-xs-left">
                        <v-btn flat icon v-if="props.item.ativo" color="green lighten-2">
                            <v-icon>check_circle</v-icon>ATIVO
                        </v-btn>

                        <v-btn flat icon v-else color="error">
                            <v-icon>cancel</v-icon>INATIVO
                        </v-btn>
                    </td>
                    <td class="text-xs-right">
                        <v-tooltip lazy v-if="props.item.ativo" bottom>
                            <v-btn icon color="red" slot="activator" flat @click="desativarRede(props.item)">
                                <v-icon>close</v-icon>
                            </v-btn>Desativar Rede
                        </v-tooltip>
                        <v-tooltip lazy v-else bottom>
                            <v-btn icon flat color="green" slot="activator" @click="ativarRede(props.item)">
                                <v-icon>check</v-icon>
                            </v-btn>Ativar Rede
                        </v-tooltip>
                    </td>
                    <td>
                        <v-tooltip lazy bottom>
                            <v-btn icon slot="activator">
                                <v-icon color="info" @click="redeSelecionada = props.item, dialogEditar = true">edit</v-icon>
                            </v-btn>Editar Dados
                        </v-tooltip>
                        <v-tooltip lazy bottom>
                            <v-btn slot="activator" flat icon color="primary" @click="dialogDetalhes = true, redeSelecionada = props.item">
                                <v-icon>remove_red_eye</v-icon>
                            </v-btn>
                            Visualizar dados da rede
                        </v-tooltip>
                        <v-tooltip bottom>
                            <v-btn icon slot="activator" flat color="error" @click="deletarRede(props.item)">
                                <v-icon>delete</v-icon>
                            </v-btn>
                            <span>Deletar Rede</span>
                        </v-tooltip>
                    </td>
                </template>
            </v-data-table>
            <div class="text-xs-center pt-2">
                <v-pagination color="info" circle v-model="pagination.page" :length="pages"></v-pagination>
            </div>
        </v-flex>
    </v-layout>

    <!-- Snackbars e Dialogs -->
    <v-snackbar
        v-model="snackbar.active"
        :color="snackbar.color"
        :multi-line="snackbar.multiLine"
        :timeout="snackbar.timeout"
        :vertical="snackbar.vertical"
    >
        {{ snackbar.text }}
        <v-btn flat @click="snackbar.active = false">Fechar</v-btn>
    </v-snackbar>

    <v-dialog v-model="dialogDetalhes" lazy width="600" :fullscreen="$vuetify.breakpoint.xs">
        <dialog-detalhes
            :rede="redeSelecionada"
            @fechar="dialogDetalhes = false, redeSelecionada = undefined"
        />
    </v-dialog>

    <v-dialog v-model="dialogEditar" width="50em" persistent scrollable>
        <dialog-editar
            :rede="redeSelecionada"
            @fechar="dialogEditar = false, redeSelecionada = undefined"
            @error="showError"
            @editado="showInfo"
            @carregar="carregarRedes"
        >
        </dialog-editar>
    </v-dialog>

    <v-dialog v-model="dialogFirebase" width="50em" scrollable>
        <dialog-projetos-firebase
            @success="showInfo"
            @error="showError"
            @fechar="dialogFirebase = false"
        />
    </v-dialog>

    <v-dialog v-model="dialogCadRede" width="50em" scrollable>
        <cad-rede-empresas
            @success="showInfo"
            @error="showError"
            @fechar="dialogCadRede = false"
        />
    </v-dialog>

    <v-dialog width="500" v-model="dialogDeletar">
        <deletar-rede
            :rede="redeSelecionada"
            @fechar="dialogDeletar = false"
            @success="showInfo"
            @error="showError"
            @carregar="carregarRedes"
        />
    </v-dialog>
</v-container>

</template>

<script>

import CadRedeEmpresas from '@/components/cadastros/CadRedeEmpresas.vue'
import dialogDetalhes from '@/components/dialogs/DetalhesRedeEmpresa.vue'
import dialogEditar from '@/components/dialogs/EditarRedeEmpresa.vue'
import DeletarRede from '@/components/dialogs/DeletarRede.vue'
import DialogProjetosFirebase from '@/components/dialogs/ProjetosFirebase'
import SmartLockMessage from '@/components/SmartLockMessage.vue'

export default {
name: 'RedeEmpresas',
components: {
    CadRedeEmpresas,
    dialogDetalhes,
    dialogEditar,
    DeletarRede,
    DialogProjetosFirebase,
    SmartLockMessage
},
data () {
    return {
        searchingRede: false,
        dialogDetalhes: false,
        redeSelecionada: undefined,
        dialogEditar: false,
        dialogDeletar: false,
        dialogFirebase: false,
        dialogCadRede: false,
        snackbar: {
            active: false,
            color: '',
            multiLine: true,
            timeout: 4000,
            vertical: true,
            text: ''
        },
        pagination: {
            page: 1,
            rowsPerPage: 5
        },
        filtro: undefined,
        campoPesquisa: undefined,
        searchTimer: null,
        redes: [],
        totalItens: 0
    }
},
computed: {
    smartLock () { return this.$store.getters.smartLock },
    loading () { return this.$store.getters.loading },
    pages () {
        if (this.pagination.rowsPerPage == null || this.totalItens == null) {
            return 0
        }
        return Math.ceil(this.totalItens / this.pagination.rowsPerPage)
    }
},
mounted () {
    this.carregarRedes()
},
watch: {
    'pagination.page' (val) {
        this.carregarRedes()
    },
    filtro (val) {
        this.campoPesquisa = undefined
        this.carregarRedes()
    },
    campoPesquisa (val) {
        if (this.searchTimer) clearTimeout(this.searchTimer)
        this.searchTimer = setTimeout(() => {
            this.carregarRedes()
        }, 450)
    }
},
methods: {
    carregarRedes () {
        const payload = {
            page: this.pagination.page,
            page_size: this.pagination.rowsPerPage
        }
        if (this.filtro && typeof this.filtro === 'object' && this.campoPesquisa !== undefined && this.campoPesquisa !== null && this.campoPesquisa !== '') {
            if (this.filtro.value === 'nome__icontains') {
                payload.nome__icontains = this.campoPesquisa
            } else if (this.filtro.value === 'is_white_label') {
                payload.is_white_label = !!this.campoPesquisa
            }
        }
        this.$store.dispatch('pegarTodasRedesEmpresas', payload)
            .then(json => {
                if (Array.isArray(json)) {
                    this.redes = json
                    this.totalItens = json.length
                } else {
                    this.redes = json.results || json
                    this.totalItens = json.count || (json.results ? json.results.length : 0)
                }
            })
            .catch(() => {
                this.redes = []
                this.totalItens = 0
                this.showError('Erro ao carregar redes de empresas')
            })
    },
    showInfo (info) {
        this.snackbar.color = 'info'
        this.snackbar.text = info
        this.snackbar.active = true
    },
    showError (error) {
        this.snackbar.color = 'error'
        this.snackbar.text = error
        this.snackbar.active = true
    },
        deletarRede (item) {
            this.redeSelecionada = item
            this.dialogDeletar = true
        },
        ativarRede (rede) {
            const id = rede && (rede.id_rede_empresa)
            if (!id) return this.showError('ID da rede não encontrado.')
            this.$store.dispatch('atualizarRedeEmpresa', { id_rede_empresa: id, ativo: true })
                .then(() => {
                    this.showInfo('Rede ativada.')
                    this.carregarRedes()
                })
                .catch(() => this.showError('Erro ao ativar rede.'))
        },
        desativarRede (rede) {
            const id = rede && (rede.id_rede_empresa)
            if (!id) return this.showError('ID da rede não encontrado.')
            this.$store.dispatch('atualizarRedeEmpresa', { id_rede_empresa: id, ativo: false })
                .then(() => {
                    this.showInfo('Rede desativada.')
                    this.carregarRedes()
                })
                .catch(() => this.showError('Erro ao desativar rede.'))
        },
        buscarAgora () {
            if (this.searchTimer) {
                clearTimeout(this.searchTimer)
                this.searchTimer = null
            }
            this.carregarRedes()
        }
}
}
</script>

<style scoped>
h1,
h2 { font-weight: normal; }
ul { list-style-type: none; padding: 0; }
li { display: inline-block; margin: 0 10px; }
a { color: #42b983; }
</style>
